export default __webpack_public_path__ + "static/media/canimmunize-marked.cf11e70e.png";